/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import {
  DateInput,
  NumberInput,
  SelectInput,
  TextInput,
} from '@framework/form';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { stripHtmlForDisplay } from '../../../../ui/html/stripHtmlForDisplay';
import { Datatype, FieldDatatype } from '../Datatype';
import { FieldDatatypeBooleanInput } from './FieldDatatypeBooleanInput';
import { $InputContainer } from './FieldDatatypeBooleanInput.style';

export interface IFieldDatatypeValueInputProps {
  name: string;
  field: FieldDatatype;
  size?: SizeType;
  disabled?: boolean;
}

export function FieldDatatypeValueInput(props: IFieldDatatypeValueInputProps) {
  const { field, name, size, disabled } = props;

  if (field.type === Datatype.Array && field.itemsType === Datatype.Object) {
    return (
      <$InputContainer>
        <span>Non supportato</span>
      </$InputContainer>
    );
  }

  if (field.options && field.type !== Datatype.Array) {
    return (
      <SelectInput
        name={name}
        size={size || 'middle'}
        options={
          field.options?.map(o => ({
            ...o,
            label: stripHtmlForDisplay(o.label),
          })) ?? []
        }
        popupMatchSelectWidth={false}
        rootClassName="full-text-options"
        allowClear
        onChange={(value, option, onChange) => {
          if (disabled) return;
          onChange(value ?? null);
        }}
        disabled={disabled}
      />
    );
  }

  switch (field.type) {
    case Datatype.Array: {
      return (
        <SelectInput
          disabled={disabled}
          name={name}
          size={size ?? 'middle'}
          notFoundContent={!field.options ? null : undefined}
          style={{ minWidth: '180px' }}
          placeholder={
            field.options ? 'Seleziona...' : 'Scrivi e premi invio...'
          }
          mode={field.options ? 'multiple' : 'tags'}
          rootClassName="full-text-options"
          popupMatchSelectWidth={false}
          options={
            field.options?.map(o => ({
              ...o,
              label: stripHtmlForDisplay(o.label),
            })) ?? []
          }
          allowClear
          onChange={(value, option, onChange) => {
            onChange(value ?? null);
          }}
        />
      );
    }

    case Datatype.String:
      return (
        <TextInput name={name} size={size ?? 'middle'} disabled={disabled} />
      );
    case Datatype.Number:
      return (
        <NumberInput name={name} size={size ?? 'middle'} disabled={disabled} />
      );
    case Datatype.Boolean:
      return <FieldDatatypeBooleanInput name={name} disabled={disabled} />;
    case Datatype.Date:
      return (
        <DateInput name={name} size={size ?? 'middle'} disabled={disabled} />
      );
    default:
      return (
        <$InputContainer>
          <span>Non supportato</span>
        </$InputContainer>
      );
  }
}
